import { useContext } from 'react';
import {
    TasksAndAlertsUserActivityContext,
    TasksAndAlertsUserActivityContextData
} from './context';

export function useTasksAndAlertsUserActivity(): TasksAndAlertsUserActivityContextData {
    const data = useContext<TasksAndAlertsUserActivityContextData | undefined>(
        TasksAndAlertsUserActivityContext
    );

    if (!data) {
        throw new Error(
            "TasksAndAlertsUserActivityContext unavailable. Are you sure you're using this in a nested component of an TasksAndAlertsUserActivityProvider?"
        );
    }

    return data;
}
